export default __webpack_public_path__ + "0362f62a85b9cf39421f824303549ca1.png";